import { mailOutline } from 'ionicons/icons';
import { DataEntry } from './DataEntry';

export const EmailEntry = ({ email }) => (
  <DataEntry icon={mailOutline} >
    {email && <a href={`mailto:${email}`}>{email}</a>}
  </DataEntry>
);
